module.exports = __webpack_public_path__ + "img/shopping-bag-02.e8d0cd36.svg";